import { Link } from '@/components/design-system';
import {
  PADDING_X,
  PADDING_Y,
  FONT_WEIGHTS,
  COLOR_SCALE,
  RADIUS_SCALE,
  INTERACTIVE_STATES,
  MARGIN_BOTTOM,
} from '@/components/design-system/tokens';
import { createPageUrl } from '@/utils';

interface NavigationLinksUser {
  role?: string;
  is_admin?: boolean;
  is_marketer?: boolean;
  is_partner?: boolean | null;
  partner_category?: string | null;
  assigned_provider_ids?: string | string[] | null;
}

interface NavigationLinksProps {
  scrollToTop: () => void;
  onClose: () => void;
  user: NavigationLinksUser | null;
  t: (
    namespace: string,
    key: string,
    fallback?: string,
    variables?: Record<string, unknown>
  ) => string;
}

export const NavigationLinks = ({ scrollToTop, onClose, user, t }: NavigationLinksProps) => (
  <div className={`${MARGIN_BOTTOM['2']}`}>
    <div className={`${PADDING_X['3']} ${MARGIN_BOTTOM['3']}`}>
      <p
        className={`text-xs ${FONT_WEIGHTS.semibold} ${COLOR_SCALE['icon-muted']} uppercase tracking-wider`}
      >
        {t('mobile_menu', 'navigation_heading', 'Navigation')}
      </p>
    </div>

    <Link
      to={createPageUrl('Home')}
      onClick={() => {
        scrollToTop();
        onClose();
      }}
      className={`block ${PADDING_X['4']} ${PADDING_Y['3']} ${RADIUS_SCALE.xl} hover:${COLOR_SCALE.surface} hover:shadow-sm ${INTERACTIVE_STATES.transitions.all} focus:outline-none ${INTERACTIVE_STATES.focus.ring}`}
    >
      <span
        className={`${FONT_WEIGHTS.normal} ${COLOR_SCALE['admin-heading']} hover:${COLOR_SCALE.foreground}`}
      >
        {t('navigation', 'home', 'Home')}
      </span>
    </Link>

    <Link
      to={createPageUrl('Providers')}
      title="Browse medical providers and clinics in South Korea"
      onClick={() => {
        scrollToTop();
        onClose();
      }}
      className={`block ${PADDING_X['4']} ${PADDING_Y['3']} ${RADIUS_SCALE.xl} hover:${COLOR_SCALE.surface} hover:shadow-sm ${INTERACTIVE_STATES.transitions.all} focus:outline-none ${INTERACTIVE_STATES.focus.ring}`}
    >
      <span
        className={`${FONT_WEIGHTS.normal} ${COLOR_SCALE['admin-heading']} hover:${COLOR_SCALE.foreground}`}
      >
        {t('navigation', 'providers', 'Providers')}
      </span>
    </Link>

    <Link
      to={createPageUrl('Doctors')}
      onClick={() => {
        scrollToTop();
        onClose();
      }}
      className={`block ${PADDING_X['4']} ${PADDING_Y['3']} ${RADIUS_SCALE.xl} hover:${COLOR_SCALE.surface} hover:shadow-sm ${INTERACTIVE_STATES.transitions.all} focus:outline-none ${INTERACTIVE_STATES.focus.ring}`}
    >
      <span
        className={`${FONT_WEIGHTS.normal} ${COLOR_SCALE['admin-heading']} hover:${COLOR_SCALE.foreground}`}
      >
        {t('navigation', 'doctors', 'Doctors')}
      </span>
    </Link>

    <Link
      to={createPageUrl('Treatments')}
      onClick={() => {
        scrollToTop();
        onClose();
      }}
      className={`block ${PADDING_X['4']} ${PADDING_Y['3']} ${RADIUS_SCALE.xl} hover:${COLOR_SCALE.surface} hover:shadow-sm ${INTERACTIVE_STATES.transitions.all} focus:outline-none ${INTERACTIVE_STATES.focus.ring}`}
    >
      <span
        className={`${FONT_WEIGHTS.normal} ${COLOR_SCALE['admin-heading']} hover:${COLOR_SCALE.foreground}`}
      >
        {t('navigation', 'treatments', 'Treatments')}
      </span>
    </Link>

    <Link
      to={createPageUrl('Equipments')}
      onClick={() => {
        scrollToTop();
        onClose();
      }}
      className={`block ${PADDING_X['4']} ${PADDING_Y['3']} ${RADIUS_SCALE.xl} hover:${COLOR_SCALE.surface} hover:shadow-sm ${INTERACTIVE_STATES.transitions.all} focus:outline-none ${INTERACTIVE_STATES.focus.ring}`}
    >
      <span
        className={`${FONT_WEIGHTS.normal} ${COLOR_SCALE['admin-heading']} hover:${COLOR_SCALE.foreground}`}
      >
        {t('navigation', 'equipments', 'Equipments')}
      </span>
    </Link>

    {user && (
      <Link
        to={createPageUrl('Favorites')}
        onClick={() => {
          scrollToTop();
          onClose();
        }}
        className={`block ${PADDING_X['4']} ${PADDING_Y['3']} ${RADIUS_SCALE.xl} hover:${COLOR_SCALE.surface} hover:shadow-sm ${INTERACTIVE_STATES.transitions.all} focus:outline-none ${INTERACTIVE_STATES.focus.ring}`}
      >
        <span
          className={`${FONT_WEIGHTS.normal} ${COLOR_SCALE['admin-heading']} hover:${COLOR_SCALE.foreground}`}
        >
          {t('navigation', 'favorites', 'Favorites')}
        </span>
      </Link>
    )}
  </div>
);
